import axios from "axios";
import Vue from "vue";

const gameApi = axios.create({
  baseURL: process.env.VUE_APP_GAME_API,
  withCredentials: true,
});

gameApi.interceptors.request.use(
  function (config) {
    
    config.headers['access-control-allow-origin'] = "https://2ez.bet";
    config.headers.common['access-control-allow-origin'] = "https://2ez.bet";
    if (Vue.$cookies.isKey("_token")) {
      config.headers["Authorization"] = "Bearer " + Vue.$cookies.get("_token");
    }
    if (Vue.$cookies.isKey("_render_page"))
      config.headers["x-render-page"] = Vue.$cookies.get("_render_page");
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

gameApi.interceptors.response.use(
  function (response) {
    if(response.data.isBanned || response.data.onHold){
      Vue.$cookies.set("_user_status",JSON.stringify(response.data));
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default gameApi;
